@if (show) {
  <div class="pb-banner" role="status" aria-live="polite">
    <div class="pb-content">
      <mat-icon class="pb-icon" aria-hidden="true">shield</mat-icon>
      <span class="pb-text">
        ALERT: Please review and acknowledge the data privacy agreement to unlock all features.
      </span>
    </div>
    <div class="pb-actions">
      <button mat-flat-button class="pb-btn-review" (click)="review()">Review agreement</button>
    </div>
  </div>
}
